import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["action"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "dialog-fade",
      onAfterEnter: _ctx.afterEnter,
      onAfterLeave: _ctx.afterLeave
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          style: _normalizeStyle(_ctx.position),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMenu && _ctx.handleMenu(...args))),
          ref: "eleRef",
          class: "zm-tree-contextmenu"
        }, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_ctx.editable || !['add', 'edit', 'delete'].includes(item.command))
                  ? (_openBlock(), _createElementBlock("li", {
                      class: "zm-tree-menu-item",
                      action: item.command,
                      key: item.command
                    }, _toDisplayString(item.name), 9, _hoisted_1))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256))
          ]),
          _withDirectives(_createElementVNode("textarea", {
            class: "copy-textarea",
            ref: "inputRef",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.copyText) = $event))
          }, null, 512), [
            [_vModelText, _ctx.copyText]
          ])
        ], 4), [
          [_vShow, _ctx.modelValue]
        ])
      ]),
      _: 1
    }, 8, ["onAfterEnter", "onAfterLeave"])
  ]))
}